import keyMirror from 'keymirror';

export default keyMirror({
  SET_MINIMIZED_VIEW: null,
  CLOSE_SIDEBAR: null,
  OPEN_SIDEBAR: null,
});



// WEBPACK FOOTER //
// ./application/actions/actionTypes.js